/**
 * Marca da empresa nas telas públicas do cliente (topo e imagens). Compartilhado para
 * "Meus agendamentos" e "Planos" mostrarem exatamente o mesmo cabeçalho.
 */

export const resolvePublicAssetUrl = (url) => {
    if (!url) return null;
    if (/^https?:\/\//i.test(url)) return url;
    return `${process.env.REACT_APP_API_URL}${url.startsWith('/') ? url : `/${url}`}`;
};

export const getHeroStyle = (companyInfo) => {
    if (!companyInfo?.bannerUrl) {
        return companyInfo?.headerColor ? { background: companyInfo.headerColor } : undefined;
    }

    return {
        backgroundColor: companyInfo?.headerColor || '#232c3a',
    };
};

/** Variáveis de cor usadas pelo CSS do agendamento, derivadas da cor da empresa. */
export const getBrandVars = (companyInfo) => {
    const brandColor = companyInfo?.headerColor || '#333';
    return {
        '--booking-accent': brandColor,
        '--booking-accent-strong': `color-mix(in srgb, ${brandColor} 80%, #000)`,
        '--booking-accent-soft': `color-mix(in srgb, ${brandColor} 12%, #fff)`,
        '--booking-ink': '#1b2333',
        '--booking-muted': '#728095',
        '--booking-line': '#dbe3ec',
        '--booking-surface-alt': '#f4f7fb'
    };
};

export const formatBrl = (value) => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
